export default __webpack_public_path__ + "static/media/arrowdown.4b453b01.svg";